module.exports = __webpack_public_path__ + "static/map-mobile-17bf534d598e97c7a42d338fd47c8acc.png";